<template>
  <section id="section-users">
    <Styles>
      <b-modal
          v-model="isCardModalActive"
          :width="850"
          scroll="keep"
          :on-cancel="onCancelModalEmailPhone"
      >
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head header-modal">
            <p class="modal-card-title" style="color: white">
              <i class="mr-2 mdi mdi-email"></i
              >{{
                modalPhone
                    ? "Agregar Teléfonos"
                    : "Agregar Correos Electrónicos"
              }}
            </p>
          </header>
          <section class="modal-card-body" v-if="!modalPhone">
            <vs-alert
                title="Error"
                :active="errorsModal.show"
                color="danger"
                class="mb-3"
            >
              {{ errorsModal.message }}
            </vs-alert>
            <div
                class="columns pl-3 pr-3 pt-3 pb-3"
                v-if="emails == null || emails.length === 0"
            >
              <b-button type="is-info" @click="addNewEmail()"
              ><i class="mdi mdi-plus"></i> Agregar correo
              </b-button
              >
            </div>
            <div class="columns" v-for="(email, index) in emails" :key="index">
              <div class="column">
                <b-field label="Correo:">
                  <b-input
                      expanded
                      type="email"
                      :value="email.email"
                      v-model="email.email"
                      required
                  >
                  </b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Tipo:">
                  <b-select
                      placeholder="Seleccione un Tipo de Correo"
                      v-model="email.type"
                      expanded
                  >
                    <option
                        v-for="option in emailTypes"
                        :value="option.id"
                        :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-one-fifth">
                <b-button
                    v-if="email.add"
                    type="is-info"
                    class="modal-button-custom"
                    @click="addNewEmail()"
                ><i class="mdi mdi-plus"></i
                ></b-button>
                <b-button
                    type="is-danger"
                    class="modal-button-custom"
                    @click="deleteEmail(index)"
                ><i class="mdi mdi-minus"></i
                ></b-button>
              </div>
            </div>
          </section>
          <section class="modal-card-body" v-else>
            <vs-alert
                title="Danger"
                :active="errorsModal.show"
                color="danger"
                class="mb-3"
            >
              {{ errorsModal.message }}
            </vs-alert>
            <div
                class="columns pl-3 pr-3 pt-3 pb-3"
                v-if="phones == null || phones.length === 0"
            >
              <b-button type="is-info" @click="addNewPhone()"
              ><i class="mdi mdi-plus"></i> Agregar teléfono
              </b-button
              >
            </div>
            <div class="columns" v-for="(phone, index) in phones" :key="index">
              <div class="column">
                <b-field label="Teléfono:">
                  <b-input
                      expanded
                      type="text"
                      :value="phone.phone"
                      v-model="phone.phone"
                      required
                  >
                  </b-input>
                </b-field>
              </div>
              <div class="column">
                <b-field label="Tipo:">
                  <b-select
                      placeholder="Seleccione un Tipo de Telefono"
                      v-model="phone.type"
                      expanded
                  >
                    <option
                        v-for="option in emailTypes"
                        :value="option.id"
                        :key="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-one-fifth">
                <b-button
                    v-if="phone.add"
                    type="is-info"
                    class="modal-button-custom"
                    @click="addNewPhone()"
                ><i class="mdi mdi-plus"></i
                ></b-button>
                <b-button
                    type="is-danger"
                    class="modal-button-custom"
                    @click="deletePhone(index)"
                ><i class="mdi mdi-minus"></i
                ></b-button>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <b-button
                type="is-info"
                label="Aceptar"
                @click="modalPhone ? acceptNewPhones() : acceptNewEmails()"
            />
            <b-button
                type="is-danger"
                label="Cancelar"
                @click="modalPhone ? deletePhones() : deleteEmails()"
            />
          </footer>
        </div>
      </b-modal>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
      <main>
        <header class="header">
          <div class="container-full">
            <img
                src="../../../assets/images/logo/accesspark.svg"
                class="logo-img"
            />
            <div class="list-options">
              <div class="option-item">
                <a
                    href="https://accesspark.co/"
                    target="_blank"
                    class="item-link"
                >Accesspark.co</a
                >
              </div>
              <div class="option-item">
                <a class="item-link active">Formulario</a>
              </div>
            </div>
          </div>
        </header>
        <div class="body">
          <div class="container-full">
            <div class="left-panel">
              <div class="left-container">
                <h1 class="title">
                  Formulario de creación de factura electrónica
                </h1>
                <div class="list-options">
                  <div class="option-item">
                    <div class="number">
                      <span>1</span>
                    </div>
                    <label class="label"
                    >Regístrate en el formulario a continuación.</label
                    >
                  </div>
                  <div class="option-item">
                    <div class="number">
                      <span>2</span>
                    </div>
                    <label class="label"
                    >Antes de realizar tu pago indicale al operario de caja
                      dónde estás inscrito y quieres factura electrónica.</label
                    >
                  </div>
                  <div class="option-item">
                    <div class="number">
                      <span>3</span>
                    </div>
                    <label class="label"
                    >Listo! recibe tu factura en tu correo electrónico.</label
                    >
                  </div>
                </div>
                <div class="form-block">
                  <h2 class="title">
                    Creación de clientes para generación facturación electrónica
                  </h2>
                  <div class="columns center mt-2">
                    <div class="column is-6">
                      <b-field label="Tipo de persona *">
                        <b-select
                            placeholder="Seleccione una opción"
                            expanded
                            v-model="entityType"
                            name="entityType"
                            v-validate="'required'"
                        >
                          <option
                              v-for="option in entityTypes"
                              :value="option.code"
                              :key="option.code"
                              :id="option.code"
                          >
                            {{ option.title }}
                          </option>
                        </b-select>
                      </b-field>
                      <span class="show-error">{{
                          errors.first("entityType")
                        }}</span>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column">
                      <b-field label="Regimen *">
                        <b-select
                            placeholder="Seleccione una opción"
                            expanded
                            v-model="regime"
                            name="regime"
                            v-validate="'required'"
                        >
                          <option
                              v-for="option in regimensList"
                              :value="option.code"
                              :key="option.code"
                              :id="option.code"
                          >
                            {{ option.title }}
                          </option>
                        </b-select>
                      </b-field>
                      <span class="show-error">{{
                          errors.first("regime")
                        }}</span>
                    </div>
                    <div class="column">
                      <b-field label="Identificación *">
                        <b-input
                            placeholder="Identificación"
                            type="text"
                            name="identification"
                            v-model="identification"
                            v-validate="'required|numeric'"
                        />
                      </b-field>
                      <span class="show-error">{{
                          errors.first("identification")
                        }}</span>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column">
                      <b-field label="Nombre completo *">
                        <b-input
                            class="uppercase"
                            placeholder="Nombre del tercero"
                            type="text"
                            name="name"
                            v-model="name"
                            v-validate="'required'"
                        />
                      </b-field>
                      <span class="show-error">{{ errors.first("name") }}</span>
                    </div>
                    <div class="column">
                      <b-field label="Teléfonos *">
                        <b-input
                            v-validate="'required'"
                            placeholder="Teléfonos"
                            type="text"
                            name="phone"
                            :value="phone"
                            disabled
                            expanded
                        ></b-input>
                        <b-button
                            title="Agregar teléfono"
                            class="button is-info is-light"
                            @click="openModal('phone')"
                        ><i class="mr-2 mdi mdi-tooltip-edit"></i
                        ></b-button>
                      </b-field>
                      <span class="show-error">{{
                          errors.first("phone")
                        }}</span>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column">
                      <b-field label="Correos electrónicos *">
                        <b-input
                            placeholder="Correos electrónicos"
                            type="text"
                            disabled
                            expanded
                            name="email"
                            v-validate="'required'"
                            :value="email"
                        ></b-input>
                        <b-button
                            class="button is-info is-light"
                            @click="openModal()"
                        ><i class="mr-2 mdi mdi-tooltip-edit"></i
                        ></b-button>
                      </b-field>
                      <span class="show-error">{{
                          errors.first("email")
                        }}</span>
                    </div>
                    <div class="column">
                      <b-field label="Responsable Fiscal *">
                        <b-select
                            placeholder="Seleccione una opción"
                            expanded
                            v-model="fiscalResponsibility"
                            name="fiscalResponsibility"
                            v-validate="'required'"
                        >
                          <option
                              v-for="option in fiscalList"
                              :value="option.code"
                              :key="option.code"
                              :id="option.code"
                          >
                            {{ option.title }}
                          </option>
                        </b-select>
                      </b-field>
                      <span class="show-error">{{
                          errors.first("fiscalResponsibility")
                        }}</span>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column location-component">
                      <b-field label="Ciudad *">
                        <Autocomplete
                            name="city"
                            :options="cities"
                            :v-model="city"
                            placeholder="Buscar..."
                            @onChange="onChange"
                            @getCities="getCities"
                        />
                      </b-field>
                      <span class="show-error">{{ errors.first("city") }}</span>
                    </div>
                    <div class="column">
                      <b-field label="Código postal *">
                        <b-input
                            placeholder="Código postal"
                            type="text"
                            name="zipCode"
                            v-model="zipCode"
                            v-validate="'required|numeric'"
                        />
                      </b-field>
                      <span class="show-error">{{
                          errors.first("zipCode")
                        }}</span>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column">
                      <b-field label="Dirección *">
                        <b-input
                            placeholder="Dirección"
                            type="text"
                            name="address"
                            v-model="address"
                            v-validate="'required'"
                        />
                      </b-field>
                      <span class="show-error">{{
                          errors.first("address")
                        }}</span>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column">
                      <b-field label="Indicaciones">
                        <b-input
                            placeholder="Indicaciones"
                            type="textarea"
                            rows="3"
                            name="indications"
                            v-model="indications"
                        />
                      </b-field>
                      <span class="show-error">{{
                          errors.first("indications")
                        }}</span>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column">
                      <b-checkbox
                          name="agreement"
                          v-model="agreement"
                          true-value="Y"
                          false-value="N"
                      >
                        Autorizo a AccessPark S.A.S a realizar el tratamiento de
                        mis datos personales de acuerdo con su
                        <a href="">Política de Tratamiento de Datos</a>
                      </b-checkbox>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column">
                      <b-checkbox
                          name="check"
                          v-model="check"
                          true-value="Y"
                          false-value="N"
                      >
                        Suscribirte a nuestras ofertas y noticias mediante tu
                        correo electrónico.
                      </b-checkbox>
                    </div>
                  </div>
                  <div class="columns" v-if="entityType">
                    <div class="column">
                      <vs-button
                          color="primary"
                          class="pl-5 pr-5 btn-send"
                          type="filled"
                          @click="save()"
                      >
                        Enviar formulario
                      </vs-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="right-panel">
              <div class="image-circled">
                <a href="https://accesspark.co/" target="_blank">
                  <img
                      src="../../../assets/images/logo/accesspark.svg"
                      class="logo-image"
                  />
                </a>
              </div>
              <div class="details-container mt-3">
                <label class="title">Dirección:</label>
                <div class="map-container">
                  <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3921.829499349325!2d-74.06412931599046!3d4.668789475626912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3f9b62c04b0d01%3A0x6768025aef953a3d!2sAccesspark!5e0!3m2!1ses-419!2sco!4v1643056237360!5m2!1ses-419!2sco"
                      width="400"
                      height="300"
                      style="border: 0"
                      class="map-iframe"
                      allowfullscreen=""
                      loading="lazy"
                  ></iframe>
                </div>
                <p class="item-details mt-2">Bogotá - Colombia</p>
                <p class="item-details">Carrera 22 # 80 - 59</p>
              </div>
              <div class="details-container mt-3">
                <label class="title">Cualquier inquietud:</label>
                <p class="item-details">
                  <img src="https://flagcdn.com/w20/co.png" class="mr-3"/> +57
                  314 552 7201
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Styles>
  </section>
</template>
<script>
import Styles from "./styles";
import Autocomplete from "../../../components/Shared/Autocomplete";
import {ROUTES} from "../../../global/api_routes";
import {configToast, TOAST_TYPES} from "../../../global/toast";
import {get as getProp} from "object-path";

export default {
  name: "UsersRegister",
  components: {Styles, Autocomplete},
  data: () => ({
    actualCode: null,
    check: "Y",
    agreement: "Y",
    isLoading: false,
    name: null,
    companies: null,
    phone: null,
    email: null,
    regime: null,
    identification: null,
    company: null,
    indications: null,
    municipio: null,
    zipCode: null,
    city: null,
    address: null,
    identificationType: null,
    regimeList: null,
    entityType: null,
    entityTypes: null,
    fiscal: null,
    country: null,
    location: null,
    countriesList: null,
    departament: null,
    departamentList: null,
    editModal: false,
    fiscalResponsibility: null,
    selectedEdit: null,
    searchModal: null,
    tempLocation: null,
    hackFill: 0,
    usersEditList: [],
    regimensList: [],
    identificationTypes: [],
    fiscalList: [],
    locationList: [],
    cities: [],
    emails: [],
    phones: [],
    emailTypes: [
      {name: "Personal", id: "P"},
      {name: "Trabajo", id: "W"},
      {name: "Otro", id: "O"},
    ],
    extraInfo: [
      {
        title: null,
        value: null,
        order: null,
        type: null,
        add: true,
      },
    ],
    isCardModalActive: false,
    modalPhone: false,
    modalInfo: false,
    extraInfoEditing: null,
    errorsModal: {
      message: "",
      show: false,
    },
    errorsModalInfo: {
      message: "",
      show: false,
    },
  }),
  watch: {
    entityType: async function () {
      if (!this.entityType) {
        return;
      }
      await this.getComboxList();
      this.checkGenericUser();
    },
    city: function () {
      console.log("CITY CHANGE", this.city);
      this.autoCompleteZipCode();
    },
    cities: function () {
      console.log("CITIES", this.cities);
    },
  },
  mounted() {
    this.initQueries();
  },
  methods: {
    onChange(city) {
      this.city = city;
    },
    getCities({action, searchQuery, callback}) {
      if (action === "ASYNC_SEARCH") {
        if (searchQuery.length < 2) {
          return;
        }
        this.$http
            .get(ROUTES.GLOBAL.GET_CITIES, {
              params: {
                search: searchQuery,
              }
            })
            .then(({data}) => {
              if (data.code > 0) {
                this.cities = data.info;
                this.originalCities = [...data.info];
                this.processData(this.cities);
                this.cities = this.groupCities(this.cities);
                callback(null, this.cities);
              } else {
                this.cities = [];
                callback(null, []);
              }
            });
      }
    },
    cancel() {
      this.cleanForm();
    },
    onBlurIdentification() {
      if (this.identification.trim() === "") {
        return;
      }
      this.findUserByIdentification();
    },
    checkGenericUser() {
      const entityType = this.entityTypes.find(
          (item) => item.code == this.entityType
      );
      if (!entityType || entityType.initials !== "GE") {
        return;
      }
      this.regime = getProp(this.regimensList, "0.code");
      this.identificationType = getProp(this.identificationTypes, "0.code");
      this.fiscalResponsibility = getProp(this.fiscalList, "0.code");
      this.identification = "111";
      this.name = "GENERIC";
      this.phone = "0000000";
      this.email = "generic-user@accesspark.com";
    },
    isGeneric() {
      const entityType = this.entityTypes.find(
          (item) => item.code == this.entityType
      );

      return getProp(entityType, "initials") === "GE";
    },
    onCancelModalEmailPhone() {
      if (this.modalPhone) {
        this.modalPhone = false;
      }
      this.errorsModal.show = false;
      this.errorsModal.message = "";
      this.isCardModalActive = false;
    },
    fillForm(user) {
      this.actualCode = getProp(user, "code", null);
      this.entityType = getProp(user, "entityType.code", null);
      this.identificationType = getProp(user, "identificationType.code");
      this.name = user.name;
      this.address = user.address;
      this.phones = JSON.parse(getProp(user, "telephone", "[]"));
      this.emails = JSON.parse(getProp(user, "email", "[]"));
      this.regime = getProp(user, "regime.code", null);
      this.fiscalResponsibility = getProp(
          user,
          "fiscalResponsibility.code",
          null
      );
      this.city = getProp(user, "location.code");
      const location = getProp(user, "location");
      this.cities =
          location && location.code
              ? [{id: location.code, label: location.title}]
              : [];

      this.tempLocation = location;
      this.hackFill = new Date().getTime();
    },
    findUserByIdentification() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.USERS.GET_USER_BY_IDENTIFICATION, {
            params: {
              identification: this.identification,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              const user = data.info;
              this.toast(
                  "Se ha encontrado un tercero con el número de identificación encontrado",
                  TOAST_TYPES.WARNING
              );
              this.fillForm(user);
              return;
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    async initQueries() {
      this.isLoading = true;
      this.getLocations();
      const entityTypes = await this.getUnitiesByKind(14);
      this.setList(entityTypes, "entityTypes");
      this.isLoading = false;
    },
    autoCompleteZipCode() {
      const selectedCompany = this.originalCities.find(
          (item) => item.code == this.city
      );
      if (!selectedCompany) {
        return;
      }
      this.zipCode = selectedCompany.postalCode;
    },
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, "#subscription_container");
      return instance.open(message, type);
    },
    openEditModal() {
      this.editModal = true;
      this.getListUsers();
    },
    openModal(type = null) {
      if (type == "info") {
        this.modalInfo = true;
        this.modalPhone = false;
        this.isCardModalActive = false;
        return;
      }
      if (type != null) {
        this.modalPhone = true;
        this.isCardModalActive = true;
        return;
      }
      this.modalPhone = false;
      this.isCardModalActive = true;
    },
    closeEditModal() {
      this.editModal = false;
    },
    getListUsers() {
      if (this.usersEditList.length > 0) {
        return;
      }
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.ENTITY.SEARCH_USERS, {
            params: {
              search: this.searchModal,
            }
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.usersEditList = data.info;
              return;
            }
            this.usersEditList = [];
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    cleanForm() {
      this.$validator.reset();
      this.company = null;
      this.identificationType = null;
      this.identification = null;
      this.name = null;
      this.phone = null;
      this.email = null;
      this.regime = null;
      this.entityType = null;
      this.fiscalResponsibility = null;
      this.location = null;
      this.zipCode = null;
      this.address = null;
      this.searchModal = null;
      this.actualCode = null;
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          console.log(this.errors);
          this.toast("Complete el formulario", TOAST_TYPES.ERROR);
          return;
        }

        this.isLoading = true;
        this.$http
            .post(ROUTES.GLOBAL.ENTITY.SAVE_ENTITY, {
              code: this.actualCode,
              name: this.name.toUpperCase(),
              identification: this.identification,
              identificationType: this.identificationType,
              telephone: JSON.stringify(this.phones),
              email: JSON.stringify(this.emails),
              address: this.address,
              regime: {code: this.regime},
              location: {code: this.location},
              entityType: {code: this.entityType},
              indications: this.indications,
              fiscalResponsibility: {code: this.fiscalResponsibility},
              indications: this.indications,
              agreement: this.agreement,
              subscribed: this.subscribed
            })
            .then(({data}) => {
              if (data.code > 0) {
                this.toast(
                    this.actualCode
                        ? "Se ha atualizado correctament el tercero"
                        : "Se ha registrado correctament el tercero",
                    TOAST_TYPES.SUCCESS
                );
                this.cleanForm();
                return;
              }
              this.toast(data.message, TOAST_TYPES.ERROR);
            })
            .finally(() => {
              this.isLoading = false;
            });
      });
    },
    setList(response, listName) {
      this[listName] = response.data.code > 0 ? response.data.info : [];
    },
    async getComboxList() {
      this.isLoading = true;
      const companiesResponse = await this.getCompanies();
      this.setList(companiesResponse, "companies");
      this.processData(this.companies);
      //Listamos las ciudades...
      const identificationTypes = await this.getUnitiesByKind(
          1,
          this.entityType
      );
      this.setList(identificationTypes, "identificationTypes");
      const regimensList = await this.getUnitiesByKind(19, this.entityType);
      this.setList(regimensList, "regimensList");
      const fiscalList = await this.getUnitiesByKind(20, this.entityType);
      this.setList(fiscalList, "fiscalList");
      this.isLoading = false;
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let companie = companies[index];
        companie.label = companie.name ? companie.name : companie.title;
        companie.id = companie.code;
        if (companie.children) {
          this.processData(companie.children);
        }
      }
    },
    getUnitiesByKind(kindId, kindFather) {
      return this.$http.get(ROUTES.GLOBAL.ENTITY.GET_LIST_BY_KIND, {
        params: {
          kindId,
          kindFather,
        },
      });
    },
    getCompanies() {
      return this.$http.get(ROUTES.DASHBOARD.GET_COMPANIES_TREE);
    },
    getLocations() {
      return this.$http.post(ROUTES.GLOBAL.GET_CITIES);
    },
    getChildCities(cities, city) {
      city.children = cities.filter(
          (item) => getProp(item, "father.code", item.father) == city.code
      );
      city.children.forEach((city) => {
        this.getChildCities(cities, city);
      });
    },
    addNewEmail() {
      if (this.emails.length === 1) {
        this.emails[0].add = false;
      }
      if (this.emails.length > 1) {
        this.emails[this.emails.length - 1].add = false;
      }
      this.emails = [
        ...this.emails,
        {
          email: "",
          type: "",
          add: true,
        },
      ];
    },
    addNewPhone() {
      if (this.phones.length === 1) {
        this.phones[0].add = false;
      }
      if (this.phones.length > 1) {
        this.phones[this.phones.length - 1].add = false;
      }
      this.phones = [
        ...this.phones,
        {
          phone: "",
          type: "",
          add: true,
        },
      ];
    },
    deletePhones() {
      this.phones = [
        {
          phone: "",
          type: "",
          add: true,
        },
      ];
      this.isCardModalActive = false;
      this.modalPhone = false;
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      this.phone = "";
    },
    deleteEmail(index) {
      this.emails.splice(index, 1);
    },
    deletePhone(index) {
      this.phones.splice(index, 1);
    },
    acceptNewEmails() {
      for (let index = 0; index < this.emails.length; index++) {
        const email = this.emails[index];
        if (email.email === "") {
          this.errorsModal.message = "Debe ingresar todos los correos";
          this.errorsModal.show = true;
          return;
        }
        if (email.type === "") {
          this.errorsModal.message = "Debe ingresar todos los tipos de correo";
          this.errorsModal.show = true;
          return;
        }
      }
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      if (this.emails.length === 1) {
        this.isCardModalActive = false;
        return (this.email = `Se Agrego 1 correo`);
      }
      this.email = `Se Agregaron (${this.emails.length}) correos`;
      this.isCardModalActive = false;
    },
    acceptNewPhones() {
      for (let index = 0; index < this.phones.length; index++) {
        const phone = this.phones[index];
        if (phone.phone === "") {
          this.errorsModal.message = "Debe ingresar todos los telefonos";
          this.errorsModal.show = true;
          return;
        }
        if (phone.type === "") {
          this.errorsModal.message = "Debe ingresar todos los tipos de correo";
          this.errorsModal.show = true;
          return;
        }
      }
      this.errorsModal.message = "";
      this.errorsModal.show = false;
      if (this.phones.length === 1) {
        this.isCardModalActive = false;
        this.modalPhone = false;
        return (this.phone = `Se Agrego 1 telefono`);
      }
      this.phone = `Se Agregaron (${this.phones.length}) telefonos`;
      this.modalPhone = false;
      this.isCardModalActive = false;
    },
    groupCities(cities) {
      //Obtenemos los padres...
      const fathers = cities.filter(
          (item) => !getProp(item, "father.code", item.father)
      );
      fathers.forEach((city) => {
        //Buscamos los hijos de esto...
        this.getChildCities(cities, city);
      });
      return fathers;
    },
  },
};
</script>
